// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__3KpRM","loading":"style_loading__2vZVe","rotate":"style_rotate__39LRK"};